<template>
  <div class="register-page">
    <div class="login-box">
      <img :src="imgs.bgImg" alt="" width="750px" height="198px" style="position: absolute; top: 0px; left: 24px; z-index: 10" />

      <div class="login-card">
        <div class="left-img">
          <div class="left-title">
            <div class="flex">
              <div>{{ wxType ? '欢 迎 注 册' : '欢 迎 回 来' }}</div>
              <img :src="imgs.textLogo" alt="" width="26px" height="25px" style="margin: -12px 0 0 12px" />
            </div>
          </div>
          <div v-if="wxType">
            <img :src="imgs.leftImgWx" alt="" class="login-img" />
          </div>
          <div align="center" v-else>
            <img :src="imgs.leftImg" alt="" class="login-img" />
          </div>
        </div>
        <div class="right-wx" v-if="wxType">
          <div class="right-box">
            <div style="text-align: right; padding: 16px 16px 0 0">
              <img class="cursor-pointer" @click="passwordLogin" :src="imgs.returnLogo" width="116px" height="48px" />
            </div>
            <div class="wx-title">微 信 扫 码</div>
            <div style="text-align: center">
              <!-- <img v-if="" :src="imgs.wxQrcode" alt=""> -->
              <div v-if="wxCodeOld">
                <img class="cursor-pointer" @click="getQrcode" :src="imgs.codeChange" width="160px" height="160px" />
              </div>
              <div v-else>
                <div v-if="wxWait">
                  <img :src="imgs.register" width="160px" height="160px" />
                </div>
                <div v-else>
                  <img v-if="qrcode == null" :src="imgs.wxQrcode" width="160px" height="160px" />
                  <img v-else :src="`https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${qrcode ? qrcode.ticket : ''}&expire_seconds=30`" width="160px" height="160px" />
                </div>
              </div>
            </div>
            <div class="wx-text">请使用微信扫描二维码登录/注册</div>
          </div>
        </div>
        <div class="right-login" v-else>
          <div class="right-title">登 录</div>
          <el-form ref="formLogin" label-position="top" :model="partModel" size="small">
            <el-form-item label="手机号码" prop="userName">
              <div class="phone-input">
                <el-input v-model.trim="partModel.userName" placeholder="请输入手机号码"></el-input>
                <div class="phone-code">+86</div>
              </div>
            </el-form-item>
            <el-form-item label="验证码" v-if="loginText == '密码登录'">
              <div class="code-input">
                <el-input v-model="partModel.code" placeholder="请输入验证码"></el-input>

                <span v-if="!codeIsSend" type="text" class="code-send cursor-pointer" @click="showCode">发送验证码</span>
                <span v-else type="info" class="code-send">{{ count }}秒后重新发送</span>
              </div>
            </el-form-item>
            <el-form-item label="密码" prop="passWord" v-else>
              <div class="code-input">
                <el-input v-model="partModel.passWord" autofocus placeholder="请输入密码" show-password></el-input>
              </div>
            </el-form-item>
            <el-button v-if="!((partModel.passWord && partModel.userName) || (partModel.code && partModel.userName))" class="login-btn" type="primary" size="small" style="opacity: 0.5">登 录</el-button>
            <el-button v-else @click="loginBtn" class="login-btn" type="primary" size="small" :loading="loading">
              <span v-if="!loading">登 录</span>
              <span v-else>请稍后...</span>
            </el-button>

            <div style="display: flex; justify-content: space-between">
              <!-- <el-checkbox-group v-if="loginText == '验证码登录'" v-model="checked">
                <el-checkbox label="记住密码"></el-checkbox>
              </el-checkbox-group> -->
              <el-checkbox v-if="loginText == '验证码登录'" v-model="checked">记住密码</el-checkbox>
              <div v-else></div>
              <!-- <div class="password-login cursor-pointer" @click="loginTab">{{ loginText }}</div> -->
            </div>
          </el-form>
        </div>
      </div>
    </div>

    <VerCodeDialog ref="refVerCodeDialog" @startTime="startTime" />
  </div>
</template>

<script>
// import Login from './components/account.vue';
// import Qrcode from './components/code.vue';
import JcRange from '../components/JcRange.vue';
import { common } from '@/api/index';
import { httpAjax } from '@/api/ajax';
import CryptoJS from 'crypto-js';
import { GetRequest } from '@/api/config';
import { mapActions } from 'vuex';
import VerCodeDialog from './components/VerCodeDialog.vue';

const imgs = {
  bgImg: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/home/bgImg.png',
  textLogo: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/login/textLogo.png',
  leftImgWx: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/login/leftImgWx.png',
  leftImg: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/login/leftImg.png',
  returnLogo: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/login/returnLogo.png',
  codeChange: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/login/codeChange.png',
  register: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/login/register.png',
  wxQrcode: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/Qrcode.png',
  wxLogo: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/login/wxLogo.png'
};

export default {
  name: 'Register',
  components: {
    JcRange,
    VerCodeDialog
    // Qrcode
  },
  data() {
    return {
      imgs,
      loading: false,
      codeIsSend: false, // 验证码状态
      count: '',
      timer: null,
      qrcode: '',
      loginCheck: {
        // userName: [{ required: true, message: "请输入用户名", trigger: "change" }],
        // passWord: [{ required: true, message: "请输入密码", trigger: "change" }],
      },

      status: false,
      partModel: {
        userName: '',
        passWord: '',
        code: ''
      },
      checked: false,
      loginText: '密码登录',
      wxType: false,
      dialogVisible: false,

      imgVer: {
        codeImg: '',
        key: '',
        verifyCode: ''
      },
      showVerCode: false,
      submiting: false,
      errorCode: '',
      wxCodeOld: false, // 微信二维码过期
      wxWait: false // 等待注册
    };
  },
  created() {},
  mounted() {
    this.getCookie();
    if (this.partModel.passWord) {
      this.checked = true;
    }
  },
  destroyed() {
    clearTimeout(this.timer);
  },
  methods: {
    ...mapActions(['user/getUserData']),
    // 获取船公司
    getVgmCarrier() {
      httpAjax({
        url: `/services/base/data/vgm/carrier`,
        method: 'get'
      }).then(response => {
        if (response.success) {
          localStorage.setItem('vgmCarrierData', JSON.stringify(response.data));
        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          });
        }
      });
    },
    // 获取船公司
    getCpsCarrier() {
      httpAjax({
        url: `/services/base/data/cps/carrier`,
        method: 'get'
      }).then(response => {
        if (response.success) {
          localStorage.setItem('cpsCarrierData', JSON.stringify(response.data));
        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          });
        }
      });
    },
    //清除cookie
    clearCookie: function () {
      this.setCookie('', '', -1); //修改2值都为空，天数为负1天就好了
    },
    //设置cookie
    setCookie(c_name, c_pwd, exdays) {
      // Encrypt，加密账号密码
      var cipherPortId = CryptoJS.AES.encrypt(c_name + '', 'secretkey123').toString();
      var cipherPsw = CryptoJS.AES.encrypt(c_pwd + '', 'secretkey123').toString();
      console.log(cipherPortId + '/' + cipherPsw); // 打印一下看看有没有加密成功

      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数

      //字符串拼接cookie
      window.document.cookie = 'userName' + '=' + cipherPortId + ';expires=' + exdate.toGMTString();
      window.document.cookie = 'passWord' + '=' + cipherPsw + ';expires=' + exdate.toGMTString();
    },
    //读取cookie
    getCookie() {
      // console.log(document.cookie)
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        console.log(arr);
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('='); //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'userName') {
            console.log(arr2[1]);
            const name = CryptoJS.AES.decrypt(arr2[1], 'secretkey123');
            this.partModel.userName = name.toString(CryptoJS.enc.Utf8); //保存到保存数据的地方
          } else if (arr2[0] == 'passWord') {
            const pass = CryptoJS.AES.decrypt(arr2[1], 'secretkey123');
            this.partModel.passWord = pass.toString(CryptoJS.enc.Utf8);
          }
        }
      }
    },
    // 提交验证码
    enterCode() {
      if (this.imgVer.verifyCode === '') {
        this.errorCode = '请输入验证码';
        return;
      }
      this.submiting = true;
      httpAjax({
        url: '/services/verify/send/verifySms',
        method: 'get',
        data: {
          key: this.imgVer.key,
          phoneNumber: this.partModel.userName,
          verifyCode: this.imgVer.verifyCode,
          type: 'login'
        }
      }).then(response => {
        if (response.success) {
          this.showVerCode = false;
          this.codeIsSend = true;
          this.count = 60;
          this.timeFun();
        } else {
          this.errorCode = response.msg;
        }
        this.submiting = false;
      });
    },
    // 输入验证码
    changeCode(value) {
      this.imgVer.verifyCode = value;
    },
    // 显示验证码
    async showCode() {
      if (!(this.partModel.userName && this.partModel.userName.length == 11)) {
        this.$message({ message: '请输入11位手机号码', type: 'error' });
        return;
      }

      const response = await common.getVrcode();
      const { data } = response;

      if (data.success) {
        this.$refs.refVerCodeDialog.open(this.partModel.userName, 'login', data.data);
      } else {
        this.$message({ message: data.msg, type: 'error' });
      }
    },

    startTime() {
      this.codeIsSend = true;
      this.count = 60;
      this.timeFun();
    },

    // 倒计时
    timeFun() {
      this.count = 60;
      this.timer = setInterval(() => {
        if (this.count === 1) {
          this.codeIsSend = false;
          clearInterval(this.timer);
        } else {
          this.count--;
        }
      }, 1000);
    },
    // 登陆
    loginBtn() {
      if (!(this.partModel.userName && this.partModel.userName.length == 11)) {
        this.$message({
          message: '请输入11位手机号码',
          type: 'error'
        });
        return;
      }
      this.$refs['formLogin'].validate(valid => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch('user/login', this.partModel)
            .then(res => {
              console.log(11111111111122222);
              if (res.success) {
                localStorage.setItem('userData', JSON.stringify(res.data));
                this['user/getUserData']();
                this.loginPostMessage(res);
                this.getCpsCarrier();
                this.getVgmCarrier();
                this.$message({
                  message: '登录成功',
                  type: 'success',
                  offset: 80
                });
                if (GetRequest().inviteCode ? GetRequest().inviteCode.split('#')[0] : null) {
                  setTimeout(() => {
                    this.$router.push({
                      name: 'homePage',
                      query: {
                        inviteCode: GetRequest().inviteCode ? GetRequest().inviteCode.split('#')[0] : null
                      }
                    });
                  }, 500);
                } else {
                  setTimeout(() => {
                    this.$router.push({
                      name: 'homePage'
                    });
                  }, 500);
                }

                // this.$router.replace({
                // 	name: 'login',
                // })
                if (this.checked) {
                  this.setCookie(this.partModel.userName, this.partModel.passWord, 7);
                } else {
                  this.clearCookie();
                }

                // this.$emit('loginSuccess')
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  offset: 80
                });
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    // 关闭
    handleClose() {
      this.showVerCode = false;
      this.errorCode = '';
      this.imgVer.verifyCode = '';
    },
    // 打开弹窗
    openDialog() {
      // this.dialogVisible = true
      this.showCode();
    },
    // 滑动成功，获取验证码
    successRange() {
      console.log(1);
      setTimeout(() => {
        this.dialogVisible = false;
        this.codeIsSend = true;
        this.timeFun();
      }, 1000);
    },
    errorRange() {
      console.log(2);
    },
    // 密码登录
    passwordLogin() {
      this.wxType = false;
      clearTimeout(this.timer);
    },
    // 微信登录/注册
    wxLogin() {
      this.wxType = true;
      this.getQrcode();
    },
    // 获取登录二维码
    getQrcode() {
      this.wxWait = false;
      this.wxCodeOld = false;
      this.loading = true;
      httpAjax({
        url: `/services/wx/qrcode`,
        method: 'get',
        data: {
          channelCode: 'gw_website',
          type: 'LOGIN',
          source: localStorage.getItem('customerSource') ? localStorage.getItem('customerSource') : ''
        }
      }).then(response => {
        if (response.success) {
          this.qrcode = response.data;
          // 加载完二维码，开启登录检测
          this.checkLogin(response.data);
        }
        this.loading = false;
      });
    },
    // 登录切换
    loginTab() {
      this.checked = false;
      if (this.loginText == '密码登录') {
        this.loginText = '验证码登录';
        this.partModel.code = '';
      } else {
        this.loginText = '密码登录';
      }
      if (this.partModel.passWord) {
        this.checked = true;
      }
    },
    /* 检测登录状态:
     *   99: 登录成功
     *    0: 未登录
     *   -1: 需要绑定
     *   -2: 登录过期
     * */
    checkLogin(data) {
      httpAjax({
        url: '/services/wx/checkLoginInfo',
        method: 'get',
        data: {
          uid: data.uid
        }
      }).then(response => {
        if (response.success) {
          const status = response.data.status;
          // this.loginStatus = status;
          if (status === 0) {
            this.timer = setTimeout(() => {
              this.checkLogin(data);
            }, 1000);
          } else if (status === -1) {
            this.loginInfo = response.data;
            this.wxWait = true;
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
              this.checkLogin(data);
            }, 1000);
          } else if (status === -3) {
            this.$message({
              message: '账号已禁用，请联系管理员',
              type: 'error'
            });
          } else if (status === 99) {
            this.getCpsCarrier();
            clearTimeout(this.timer);
            this.$store
              .dispatch('user/codeLogin', response.data)
              .then(res => {
                if (res.successLogin) {
                  this.$router.replace({ name: 'login' });
                  // this.$emit('loginSuccess')
                } else {
                  this.$message({
                    message: res.msg,
                    type: 'error'
                  });
                }
                this.loading = false;
              })
              .catch(() => {
                this.loading = false;
              });
          }
        } else {
          // 二维码已过期
          this.wxCodeOld = true;
        }
      });
    },
    //登录之后通知代理系统登录成功
    loginPostMessage(res) {
      if (window.frames[0]) {
        window.frames[0].postMessage(res, '*');
      }
    }
  }
};
</script>

<style lang="less" scoped>
.register-page {
  background: #f0f3fb;

  /deep/ .el-checkbox__inner {
    width: 16px;
    height: 16px;
  }

  /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
  /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #1170eb !important;
    background-color: #1170eb !important;
  }
  /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #1170eb !important;
  }
  /deep/ .el-checkbox__inner:hover {
    border-color: #1170eb !important;
  }
  /deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #1170eb !important;
  }

  /deep/ .el-checkbox__inner::after {
    left: 5px;
    top: 2px;
  }

  /deep/ .el-dialog {
    margin-top: 40vh !important;
    .el-dialog__header {
      padding: 16px 24px;
      border-bottom: 1px solid #f5f5f5;
    }
    .el-dialog__body {
      padding: 0 0 24px 0;
    }

    .submit-btn {
      width: 206px;
      height: 32px;
      background: rgba(17, 112, 235);
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      margin-top: 16px;
      border: none;
    }
  }
  /deep/ .el-input__inner::-webkit-input-placeholder {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #bfbfbf;
  }
  /deep/ .el-input__inner::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #bfbfbf;
  }
  /deep/ .el-input__inner:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #bfbfbf;
  }
  /deep/ .el-input__inner:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #bfbfbf;
  }

  .login-box {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    // height: 100%;
    .login-card {
      width: 1040px;
      height: 520px;
      margin-top: 80px;
      margin-bottom: 80px;
      // width: 70%;
      border-radius: 36px;
      overflow: hidden;
      z-index: 98;

      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      background-color: #ffffff;
      .left-img {
        width: 520px;
        background: #f3f7ff;
        flex-basis: 50%;
        .login-img {
          width: 520px;
          height: 233px;
          margin: 67px 0 60px 0px;
        }
        .left-title {
          height: 40px;
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 40px;
          margin: 32px 0 0 40px;
        }
        .left-text {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 24px;
          text-align: center;
          .register-text {
            font-size: 14px;
            color: #1170eb;
          }
        }
      }
      .right-wx {
        flex-basis: 50%;
        width: 520px;
        background: #f3f7ff;
        .right-box {
          width: 360px;
          height: 360px;
          margin: 80px;
          background: #fff;
          border-radius: 8px;
          .wx-title {
            text-align: center;
            height: 32px;
            font-size: 24px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #222222;
            line-height: 33px;
            margin-bottom: 24px;
          }
          .wx-text {
            text-align: center;
            height: 16px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #222222;
            line-height: 17px;
            margin-top: 12px;
          }
        }
      }
      .right-login {
        padding: 42px 64px 0 64px;
        flex-basis: 50%;
        /deep/ .el-checkbox__label {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 22px;
        }
        .password-login {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 22px;
        }
        .login-btn {
          width: 100%;
          margin-top: 8px;
          margin-bottom: 12px;
          width: 400px;
          height: 40px;
          background: #1170eb;
          border-radius: 4px;
          // opacity: 0.5;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }
        .right-title {
          height: 46px;
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 45px;
          letter-spacing: 1px;
          text-align: center;
          margin-bottom: 16px;
        }
        /deep/ .el-form-item__label {
          padding-bottom: 6px;
          height: 33px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 33px;
        }
        /deep/ .el-form-item {
          margin-bottom: 16px;
        }
        .phone-input {
          position: relative;

          /deep/ .el-input__inner {
            padding-left: 98px;
            width: 400px;
            height: 40px;
            background: #ffffff;
            border-radius: 4px;
            border: 1px solid #bfbfbf;
            font-size: 14px;
            color: #000;
          }
          .phone-code {
            position: absolute;
            top: 8px;
            left: 24px;
            // margin-right: 24px;
            padding-right: 24px;
            border-right: 1px solid #bfbfbf;

            height: 24px;
            line-height: 24px !important;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
          }
        }
        .code-input {
          position: relative;
          /deep/ .el-input__inner {
            padding-right: 50px;
            padding-left: 16px;

            font-size: 14px;
            width: 400px;
            height: 40px;
            background: #ffffff;
            border-radius: 4px;
            border: 1px solid #bfbfbf;
            color: #000;
          }
          .code-send {
            position: absolute;
            top: 8px;
            right: 16px;

            // width: 36px;
            height: 24px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #1170eb;
            line-height: 24px;
          }
        }
      }
      .line {
        margin-top: 37px;
        margin-bottom: 30px;
        width: 100%;
        height: 10px;
        border-bottom: 1px solid #ccc;
        text-align: center;
        .line-text {
          height: 24px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 14px;
        }
        span {
          display: inline-block;
          text-align: center;
          padding: 0 20px;
          background: #fff;
        }
      }
    }
  }

  .input-right {
    width: 32px;
    height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #dddddd;
  }

  .input-code {
    /deep/ .el-input__inner {
      line-height: 32px;
      width: 160px;
      height: 32px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #dddddd;
      margin-right: 9px;
    }
    /deep/ .el-input__inner::-webkit-input-placeholder {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #bfbfbf;
      line-height: 20px;
    }
  }
}
</style>
